/* eslint-disable */
// @ts-nocheck

import React, { MouseEventHandler } from "react";
import { Toggletip, ToggletipButton, ToggletipContent } from "@carbon/react";
import Button, { Icons } from "./Button";

interface IProps {
  copyContent?: string | null;
  copyField?: string;
}

const CopyButton = ({ copyContent, copyField }: IProps) => {
  if (copyContent === undefined || copyContent === null || copyContent === "") {
    return null;
  }
  return (
    <Toggletip>
      <ToggletipButton label="Additional information">
        <Button
          kind="ghost"
          className="bg-btn"
          icon={Icons.Copy}
          onClick={() => {
            navigator.clipboard.writeText(copyContent);
          }}
          dataCy="copy-"
        />
      </ToggletipButton>
      <ToggletipContent>Copied</ToggletipContent>
    </Toggletip>
  );
};
export default CopyButton;
